<template>
  <div>
    <div class="age-title">份额合计 <el-button type="text" size="small" @click="showUsed"
        v-if="usedId && usedId !== id">修改前审批通过数据</el-button></div>
    <el-table :data="[{}]" border>
      <el-table-column label="原农龄">
        <template>
          <el-input-number :precision="4" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0"
            style="width: 100%;" v-model="euFarmerAgeEntity.originAge" />
        </template>
      </el-table-column>
      <el-table-column label="婚嫁调增">
        <template>
          <el-input-number :precision="4" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0"
            style="width: 100%;" v-model="euFarmerAgeEntity.marriageAdd" />
        </template>
      </el-table-column>
      <el-table-column label="婚嫁调减">
        <template>
          <el-input-number :precision="4" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0"
            style="width: 100%;" v-model="euFarmerAgeEntity.marriageMinus" />
        </template>
      </el-table-column>
      <el-table-column label="按规定调减农龄" min-width="150px">
        <template>
          <el-input-number :precision="4" :disabled="status === 0 || InfoType === 'details'" :controls="false" :min="0"
            style="width: 100%;" v-model="euFarmerAgeEntity.regulationsAdjust" />
        </template>
      </el-table-column>
      <el-table-column label="核定农龄份额" min-width="120">
        <template>
          <el-input-number :precision="4" disabled :controls="false" style="width: 100%;" :value="getVerificationAge" />
        </template>
      </el-table-column>
      <el-table-column label="被继承">
        <template>
          <el-input-number :precision="4" disabled :controls="false" style="width: 100%;" :value="getHeirAge" />
        </template>
      </el-table-column>
      <el-table-column label="继承">
        <template>
          <el-input-number :precision="4" disabled :controls="false" style="width: 100%;" :value="getDecedentAge" />
        </template>
      </el-table-column>
      <el-table-column label="调入调出/赎回">
        <template>
          <el-input-number :precision="4" :disabled="status === 0 || InfoType === 'details'" :controls="false"
            style="width: 100%;" v-model="euFarmerAgeEntity.adjust" />
        </template>
      </el-table-column>
      <el-table-column label="合计份额" fixed="right">
        <template>
          <el-input-number :precision="4" disabled :controls="false" style="width: 100%;" :value="getTotalAge" />
        </template>
      </el-table-column>
    </el-table>
    <div class="age-title">
      <div>份额继承明细</div>

      <el-button type="text" size="small" @click="addAgeData"
        v-if="status !== 0 && InfoType !== 'details'">新增明细</el-button>
    </div>
    <div class="status-watermark-row">
      <div v-if="InfoType === 'details'" class="status-watermark"
        :style="{ color: getType.color, 'border-color': getType.color }">{{ getType.text }}</div>
      <el-table border :data="euFarmerAgeHeritageEntityList" max-height="300">
        <el-table-column label="被继承人">
          <template slot-scope="scope">
            <span>{{ scope.row.farmerName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="继承人">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inheritedFarmerNo"  filterable remote reserve-keyword placeholder="请输入关键词"
            v-if="!(status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id)"
            @change="(value) => userChange(value, scope)"
              :remote-method="remoteMethod">
              
              <el-option v-for="item in (scope.row.farmerNo === getfarmer.id ? getNocurrentFarmer : remoteMethod(scope.row.inheritedFarmerName))"
                :key="item.id" :value="item.id" :label="`${item.name || '暂无'}-${item.idCardNo || '暂无'}`">
              </el-option>
            </el-select>
            <el-select v-model="scope.row.inheritedFarmerName"  filterable remote reserve-keyword placeholder="请输入关键词"
            v-else
            @change="(value) => userChange(value, scope)" disabled
              :remote-method="remoteMethod">
            </el-select>
          </template>
        </el-table-column>

        <!-- <el-table-column label="继承人">
          <template slot-scope="scope">
            <span>{{scope.row.farmerName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="被继承人">
          <template slot-scope="scope">
            <el-select
            placeholder="请选择"
            v-model="scope.row.inheritedFarmerNo"
            :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id"
            @change="(value) => userChange(value, scope)">
              <el-option
              v-for="item in (scope.row.farmerNo === getfarmer.id ? getNocurrentFarmer : memberList)"
              :key="item.id"
              :value="item.id"
              :label="item.name"/>
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column label="份额">
          <template slot-scope="scope">
            <el-input-number :precision="4" :controls="false"
              :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id" :min="0"
              style="width: 100%;" v-model="scope.row.age" />
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark"
              :disabled="status === 0 || InfoType === 'details' || scope.row.inheritedFarmerNo === getfarmer.id"
              placeholder="请输入" />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" width="160" />
        <el-table-column label="操作" v-if="status !== 0 && InfoType !== 'details'">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="del(scope)"
              v-if="scope.row.inheritedFarmerNo !== getfarmer.id">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 审批 -->
    <div class="age-title" v-if="status !== ''">审批信息</div>
    <el-form ref="form" :model="examineInfo" v-if="status === 0 && auditInfo.approvalFlag && InfoType !== 'details'">
      <el-form-item label="审核状态" label-width="80px" prop="status" :rules="{
        required: true, message: '请选择审核状态', trigger: 'change'
      }">
        <el-select v-model="examineInfo.status">
          <el-option :value="1" label="通过" />
          <el-option :value="2" label="拒绝" />
        </el-select>
      </el-form-item>
      <el-form-item label="审核原因" label-width="80px" prop="remark">
        <el-input type="textarea" :rows="3" maxlength="200" placeholder="请输入审核原因" v-model="examineInfo.remark" />
      </el-form-item>
    </el-form>
    <!-- 审批详情 -->
    <review-process :processList="auditInfo.auditProcessEntityList" :createTime="auditInfo.createTime"
      :createUser="auditInfo.applyUser" :auditPerson="auditInfo.auditPerson" />
    <!-- 列表没有是非自己审批标识 就写详情里吧 -->
    <div style="padding-top: 20px;text-align: center;" v-if="InfoType !== 'details'">
      <el-button type="primary" @click="toExamine" v-if="status !== 0">提交审核</el-button>
      <el-button type="primary" v-else-if="status === 0 && auditInfo.approvalFlag" @click="examine">提交审核</el-button>
      <el-button type="primary" v-else @click="closeInfo">关闭</el-button>
    </div>
  </div>
</template>

<script>
import ReviewProcess from '@/components/ReviewProcess.vue'
import { BigNumber } from 'bignumber.js'
import { euFarmerAgeGetDetailForIndex, euFarmerAgeGetDetail, euFarmerAgeSubmit, euFarmerAgeAudit, listAgeInherited } from '@/api/community.js'
export default {
  data() {
    return {
      euFarmerAgeEntity: {
        originAge: '',
        marriageAdd: '',
        marriageMinus: '',
        regulationsAdjust: '',
        adjust: '',
      },
      euFarmerAgeHeritageEntityList: [],
      memberList: [],
      examineInfo: {
        status: '',
        remark: ''
      },
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      },
      status: '',
      orderId: '',
      isDetails: true,
      getfarmer: {
        id: '',
        name: ''
      },
      a: 0
    }
  },
  props: {
    id: { // 业务单id
      type: [String, Number],
      default: null
    },
    usedId: { // 上一次审批通过业务单id
      type: [String, Number],
      default: null
    },
    InfoType: {
      type: String,
      default: 'new'
    },
    farmerNo: {
      type: String,
      default: ''
    },
    farmerName: {
      type: String,
      default: ''
    },
  },
  components: {
    ReviewProcess
  },
  computed: {
    // 核定农龄 核定农龄=原农龄+调增—调减-按规定调减
    getVerificationAge() {
      const { originAge = 0, marriageAdd = 0, marriageMinus = 0, regulationsAdjust = 0 } = this.euFarmerAgeEntity
      return originAge + marriageAdd - marriageMinus - regulationsAdjust
    },
    // 被继承农龄=继承人为本人的数据农龄取和
    getDecedentAge() {
      if (!this?.getfarmer?.id) return 0
      let decedentList = this.euFarmerAgeHeritageEntityList.filter((item) => item.inheritedFarmerNo === this.getfarmer.id)
      let sum = decedentList.reduce((total, item) => BigNumber(item.age).plus(total), 0)
      return sum
    },
    // 继承农龄=被继承人为本人的数据农龄取和
    getHeirAge() {
      if (!this?.getfarmer?.id) return 0
      let heirList = this.euFarmerAgeHeritageEntityList.filter((item) => item.farmerNo === this.getfarmer.id)
      let sum = heirList.reduce((total, item) => BigNumber(item.age).plus(total), 0)
      return sum
    },
    // 合计农龄=核定农龄-被继承农龄+继承农龄+调入调出（正负表示）
    getTotalAge() {
      // let num = this.getVerificationAge - this.getHeirAge + this.getDecedentAge + this.euFarmerAgeEntity.adjust
      // let age1 = (BigNumber(this.getVerificationAge).minus(BigNumber(this.getHeirAge))).toNumber()
      // let age2 = (BigNumber(this.getDecedentAge).plus(BigNumber(this.euFarmerAgeEntity.adjust))).toNumber()
      // let num = (BigNumber(age1).plus(BigNumber(age2))).toNumber()
      return BigNumber(this.getVerificationAge).minus(BigNumber(this.getHeirAge)).plus(BigNumber(this.getDecedentAge)).plus(BigNumber(this.euFarmerAgeEntity.adjust)).toNumber()
      // return num
    },
    // add(a, b) {
    //   a = BigNumber(a)
    //   b = BigNumber(b)
    //   return a.plus(b).toNumber()
    // },
    // minus(a, b) {
    //   a = BigNumber(a)
    //   b = BigNumber(b)
    //   return a.minus(b).toNumber()
    // },
    getType() {
      let status = this.status === -1 || this.status === '' ? 3 : this.status
      let json = {
        0: {
          text: '待审批',
          color: '#ff9800'
        },
        1: {
          text: '审批通过',
          color: '#27d92f'
        },
        2: {
          text: '审批拒绝',
          color: '#f44336'
        },
        3: {
          text: '待录入',
          color: 'rgb(149 149 150)'
        },
      }
      return json[status]
    },
    // 获取当前农民信息
    // getfarmer () {
    //   let userInfo = this.memberList.find((item) => item.id === this.farmerNo)
    //   return userInfo
    // },
    // // 获取除当前农民之外的列表
    // getNocurrentFarmer () {
    //   let list = this.memberList.filter((item) => item.id !== this.farmerNo)
    //   return list
    // }
    getNocurrentFarmer() {
      let list = this.memberList
      if (this.getfarmer.id) {
        list = list.filter((item) => item.id !== this.getfarmer.id)
      }
      return list
    }
  },
  mounted() {
    // this.getMemberList()
    this.getfarmerInfo()
  },
  methods: {
    remoteMethod(query) {
      console.log(query, '3232323');
        if (query !== '') {
          this.getMemberList(query)
        } else {
          this.options = [];
        }
      },
    // 展示上一次审批记录
    showUsed() {
      localStorage.setItem('isDetails', 1)
      this.$emit('showUsed', { type: 'age', id: this.usedId })
    },
    // 获取详情
    getData() {
      if (this.InfoType === 'details' && localStorage.getItem('isDetails') === '2') {
        euFarmerAgeGetDetailForIndex({
          eventId: this.id
        }).then(res => {
          const { code, result } = res
          if (code === 0) {
            this.orderId = result.id
            this.status = result.status
            this.euFarmerAgeEntity = {
              originAge: result?.originAge || 0,
              marriageAdd: result?.marriageAdd || 0,
              marriageMinus: result?.marriageMinus || 0,
              regulationsAdjust: result?.regulationsAdjust || 0,
              adjust: result?.adjust || 0,
            }
            this.euFarmerAgeHeritageEntityList = result.farmerAgeHeritageEntityList.map(item => {
              return {
                farmerName: item.inheritedFarmerName,
                farmerNo: item.inheritedFarmerNo,
                inheritedFarmerName: item.farmerName,
                inheritedFarmerNo: item.farmerNo,
                age: item.age,
                createTime: item.createTime,
                remark: item.remark,
              }
            }) || []
            this.auditInfo = {
              auditProcessEntityList: result.auditProcessEntityList,
              createTime: result.createTime,
              applyUser: result.applyUser,
              auditPerson: result.auditPerson,
              approvalFlag: true
              // result.approvalFlag
            }
          }
        })
      } else {
        euFarmerAgeGetDetail({
          eventId: this.id
        }).then(res => {
          const { code, result } = res
          if (code === 0) {
            this.orderId = result.id
            this.status = result.status
            this.euFarmerAgeEntity = {
              originAge: result?.originAge || 0,
              marriageAdd: result?.marriageAdd || 0,
              marriageMinus: result?.marriageMinus || 0,
              regulationsAdjust: result?.regulationsAdjust || 0,
              adjust: result?.adjust || 0,
            }
            this.euFarmerAgeHeritageEntityList = result.farmerAgeHeritageEntityList.map(item => {
              return {
                farmerName: item.inheritedFarmerName,
                farmerNo: item.inheritedFarmerNo,
                inheritedFarmerName: item.farmerName,
                inheritedFarmerNo: item.farmerNo,
                age: item.age,
                createTime: item.createTime,
                remark: item.remark,
              }
            }) || []
            this.auditInfo = {
              auditProcessEntityList: result.auditProcessEntityList,
              createTime: result.createTime,
              applyUser: result.applyUser,
              auditPerson: result.auditPerson,
              approvalFlag: true
              // result.approvalFlag
            }
          }
        })
      }
    },
    // 获取人员
    getMemberList(farmerName) {
      listAgeInherited({
        pageNum: 1,
        pageSize: 1000,
        farmerName: farmerName,
        ageStatus: this.InfoType === 'new' ? 2 : 1,
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.memberList = (result.records || []).map((item) => {
            return {
              name: item.farmerName,
              idCardNo: item.idCardNo,
              id: item.farmerNo
            }
          })
          console.log(this.memberList);
          console.log(this.memberList.length);
        }
      })
    },
    // 获取当前农民信息
    getfarmerInfo() {
      // euFarmerInfoQuery({
      //   pageNum: 1,
      //   pageSize: 9999,
      // }).then(res => {
      //   const { code, result } = res
      //   if (code === 0) {
      //     let userInfo = (result.records || []).find((item) => item.farmerNo === this.farmerNo)
      //     console.log((result.records || []).find((item) => item.farmerNo === this.farmerNo), '(result.records || []).find((item) => item.farmerNo === this.farmerNo)');
      //     this.getfarmer = {
      //       name: userInfo.farmerName,
      //       id: userInfo.farmerNo
      //     }
      //     console.log(this.getfarmer);
      //   }
      // })
      setTimeout(() => {
        // this.$set(this.getfarmer, 'name', this.farmerName)
        // this.$set(this.getfarmer, 'id', this.farmerNo)
        this.getfarmer = {
          name: this.farmerName,
          id: this.farmerNo
        }
      }, 400)
    },
    // 新增继承详情
    addAgeData() {
      this.euFarmerAgeHeritageEntityList.push({
        farmerName: this.getfarmer.name,
        farmerNo: this.getfarmer.id,
        inheritedFarmerName: '',
        inheritedFarmerNo: '',
        age: '',
        createTime: '',
        remark: ''
      })
    },
    // 删除
    del(scope) {
      this.euFarmerAgeHeritageEntityList.splice(scope.$index, 1)
    },
    // 修改被继承人
    userChange(value, scope) {
      let userInfo = this.memberList.find((item) => item.id === value)
      this.euFarmerAgeHeritageEntityList[scope.$index].inheritedFarmerName = userInfo.name
    },
    // 提交审核
    toExamine() {
      let euFarmerAgeHeritageEntityList = this.euFarmerAgeHeritageEntityList.filter((item) => item.inheritedFarmerNo !== this.farmerNo)
      euFarmerAgeHeritageEntityList = euFarmerAgeHeritageEntityList.map(item => {
        return {
          farmerName: item.inheritedFarmerName,
          farmerNo: item.inheritedFarmerNo,
          inheritedFarmerName: item.farmerName,
          inheritedFarmerNo: item.farmerNo,
          age: item.age,
          createTime: item.createTime,
          remark: item.remark,
        }
      })
      euFarmerAgeSubmit({
        euFarmerAgeEntity: {
          ...this.euFarmerAgeEntity,
          totalAge: this.getTotalAge,
          checkedAge: this.getVerificationAge,
          inheritAdd: this.getDecedentAge,
          inheritMinus: this.getHeirAge,
          eventId: this.id,
          farmerNo: this.getfarmer.id,
          farmerName: this.getfarmer.name
        },
        euFarmerAgeHeritageEntityList
      }).then(res => {
        const { code } = res
        if (code === 0) {
          this.$emit('closeInfo', true)
        }
      })
    },
    // 关闭
    closeInfo() {
      this.$emit('closeInfo')
    },
    // 审核
    examine() {
      this.$refs.form.validate((vaild) => {
        if (vaild) {
          euFarmerAgeAudit({
            id: this.orderId,
            ...this.examineInfo,
          }).then(res => {
            if (res.code === 0) {
              this.$emit('closeInfo', true)
            }
          })
        }
      })
    }
  },
  watch: {
    id: {
      handler() {
        if (this.id) {
          this.getData()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.age-title {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
}

.status-watermark-row {
  position: relative;

  .status-watermark {
    position: absolute;
    right: -20px;
    top: -30px;
    height: 100px;
    width: 100px;
    border-radius: 50px;
    border: 2px dashed;
    text-align: center;
    line-height: 100px;
    z-index: 1;
    transform: rotate(-30deg);
    font-weight: 600;
  }
}
</style>